export default {"src":"/frontend-static/_next/static/media/success.ac4c80fe.svg","height":48,"width":45,"blurWidth":0,"blurHeight":0};